import React from 'react';
import styled from 'styled-components';
import Card from 'ui/components/Card';


export const NoConversation = styled.div`
  color: ${p => p.textColor};
`;

export const HeaderLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const HomeContainer = styled.div`
  position: relative;
  z-index: 1 !important;
  height: calc(100% - 10px);
  border-radius: 20px;
  overflow: hidden;
`;

HomeContainer.displayName = 'HomeContainer';

export const HomeHeader = styled(({ textColor, children, ...others }) => (
  <div {...others}>{children}</div>
))`
  color: ${p => p.textColor || 'white'};
  padding: 20px;
`;

HomeHeader.displayName = 'HomeHeader';


export const HomeHeaderCoyLogo = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 50px;
`;

HomeHeaderCoyLogo.displayName = 'HomeHeaderCoyLogo';

export const HomeHeaderTitle = styled.h4`
  font-size: 24px;
  line-height: 28px;
  margin: 10px 0 0;
  color: inherit;
  font-weight: 700;
`;

HomeHeaderTitle.displayName = 'HomeHeaderTitle';

export const HomeHeaderSubtitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-top: 11 px;
  margin-bottom: 20px;
  opacity: 0.8;
`;

HomeHeaderSubtitle.displayName = 'HomeHeaderSubtitle';

export const HomeConversation = styled.div``;

HomeConversation.displayName = 'HomeConversation';

export const HomeConversationHeader = styled.div`
  font-size: 10px;
  color: ${p => p.textColor || 'white'};
  font-weight: 700;
  line-height: 12px;
  margin-top: ${p => p.hideCompanyDetailsInWidget?'20px':'0px'}
`;

HomeConversationHeader.displayName = 'HomeConversationHeader';

export const HomeConversationList = styled.div`
  padding: 0 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  height: calc(100vh - 260px);
  margin-top: -13px;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
`;

HomeConversationList.displayName = 'HomeConversationList';

export const InsentLinkWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;

InsentLinkWrapper.displayName = 'InsentLinkWrapper';

export const NotificationContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 9;
  margin-top: 0.5rem;
`;

NotificationContainer.displayName = 'NotificationContainer';

export const HomeBackgroundSVG = styled.svg`
  position: absolute;
  z-index: -1;
  width: 100%;
`;

export const HomeBg = styled.div`
  position: absolute;
  background: white;
  width: 100%;
  height: 100%;
  z-index: -2;
  top: 10px;
`;

export const LoaderCardWrapper = styled.div`
  display: flex;
  padding: 10px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  max-height: 4.31rem;
  background-color: ${p => p.theme.palette.white};
  box-shadow: 0 17px 15px 0 rgba(80, 80, 80, 0.1);
  border-radius: 15px;
  margin-bottom: 5px;
  transition: 0.4s all;
  &:hover {
    box-shadow: 0 17px 15px 0 rgba(80, 80, 80, 0.2);
  }
`;